import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductModelInfo extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.#handleVariantUpdate);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  #handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const selector = this.dataset.productId
      ? `product-model-info[data-product-id="${this.dataset.productId}"]`
      : 'product-model-info';

    const newModelInfo = event.detail.data.html.querySelector(selector) ?? event.detail.data.html.querySelector('product-model-info');

    if (!newModelInfo) return;

    morph(this, newModelInfo, { childrenOnly: true });
  };
}

if (!customElements.get('product-model-info')) {
  customElements.define('product-model-info', ProductModelInfo);
}
